import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LAB_NAV_HEIGHT } from './constants';

interface LabHeroProps {
  onPartnerClick: () => void;
}

const LabHero: React.FC<LabHeroProps> = ({ onPartnerClick }) => {
  const { t } = useTranslation();

  const scrollToModels = () => {
    const el = document.getElementById('lab-asr');
    if (el) window.scrollTo({ top: el.offsetTop - LAB_NAV_HEIGHT, behavior: 'smooth' });
  };

  return (
    <section
      id="lab-top"
      className="relative z-10 flex min-h-[100dvh] items-end px-6 pb-20 pt-[42dvh] md:items-center md:px-[72px] md:pb-0 md:pt-0"
    >
      <div className="mx-auto w-full max-w-[1280px]">
      <div className="max-w-[620px] [text-shadow:0_2px_30px_rgba(0,0,0,0.55)]">
        <div className="font-plexmono text-[11px] tracking-[0.18em] text-lab-mist/90 md:text-xs">
          {t('lab.hero.kicker')}
        </div>
        <h1 className="mt-6 text-[clamp(38px,9vw,70px)] font-semibold leading-[1.04] tracking-[-0.03em] [text-wrap:balance]">
          <Trans
            i18nKey="lab.hero.title"
            components={{
              nb: <span className="whitespace-nowrap" />,
              listen: <span className="lab-word lab-word-listen" />,
              speak: <span className="lab-word lab-word-speak" />,
              think: <span className="lab-word lab-word-think" />,
              serve: <span className="lab-word lab-word-serve" />,
            }}
          />
        </h1>
        <p className="mt-[22px] max-w-[540px] text-[16px] leading-[1.65] text-lab-frost/75 md:text-[17.5px]">
          {t('lab.hero.subtitle')}
        </p>
        <div className="mt-[30px] flex flex-wrap gap-3">
          <button
            onClick={onPartnerClick}
            className="lab-siri rounded-full bg-lab-frost px-7 py-3.5 text-[14.5px] font-semibold text-lab-ink transition-transform hover:-translate-y-0.5"
          >
            {t('lab.hero.ctaPrimary')}
          </button>
          <button
            onClick={scrollToModels}
            className="lab-siri rounded-full border border-lab-frost/40 px-7 py-3.5 text-[14.5px] text-lab-frost transition-colors hover:border-lab-frost/70"
          >
            {t('lab.hero.ctaSecondary')}
          </button>
        </div>
        <div className="mt-10 font-plexmono text-[11px] tracking-[0.2em] text-lab-frost/40 md:mt-[60px]">
          {t('lab.hero.scrollHint')}
        </div>
      </div>
      </div>
    </section>
  );
};

export default LabHero;
